// @flow
import React, { PureComponent } from "react";
import classNames from "classnames";

type Props = {
  height: number,
  width: number,
  className: any
};

class Trash extends PureComponent<Props> {
  render() {
    const { height, width, className } = this.props;
    const classes = classNames("icone", className);

    return (
      <svg className={classes} height={height} width={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <title>Ícone lixeira</title>
        <desc>Ícone de uma lixeira</desc>
        <g id="icon-trash">
          <path d="M16,3a1,1,0,0,1-1,1H14L12.28,14.33a2,2,0,0,1-2,1.67H5.69a2,2,0,0,1-2-1.67L2,4H1A1,1,0,0,1,0,3,1,1,0,0,1,1,2H6A2,2,0,0,1,8,0a2,2,0,0,1,2,2h5A1,1,0,0,1,16,3ZM12,4H4l1.22,9.13a1,1,0,0,0,1,.87H9.79a1,1,0,0,0,1-.87Z" />
        </g>
      </svg>
    );
  }
}

export default Trash;
